module.exports = __webpack_public_path__ + "ricard.png?45e0e5477b5a3388889cb2b85f347cf5";